module.exports = __webpack_public_path__ + "static/plastic_neutral_white-6974f8913d4ad4cb63ef778efad75844.png";